export const movieApiKey = "8d2ab62c";
